import { createProductSpecsLink } from '../product-content/productSpecsLink';
import { createDomElementHandler, createSvg } from "@/scripts/utils/dom.utils";
import { PurchaseScope } from "@/scripts/components/purchase-cta/purchaseCta.model";

const getBadgeTargetHtml = (label: string, target: number, indicatorsCount: number) => {
    const indicatorsHtml = new Array(indicatorsCount)
        .fill(undefined)
        .map( (_, i) => {
            const classes = ["badge-target__indicator"];
            if( (target - 1) < i) classes.push('badge-target__indicator--empty');            
            return `<li class="${classes.join(" ")}"></li>`;            
        })
        .join(" ");
          
    return `
        <span class="badge-target__val">${label}</span>
        <ul class="badge-target__indicators">
            ${indicatorsHtml}
        </ul>
    `;
}

const getBadgeRecommendedHtml = (label: string) => {
  const svgIcon = createSvg('icon-thumbs-up-alt');
  return `
        <span class="badge-recommended__text">
          ${label}
        </span>
        ${svgIcon.outerHTML}`;
}

const normalizeRatingValue = (_val: string) => {
    let val = _val.trim();
    if(val.length === 1) {
        val+='.0';
    }
    return val.replaceAll('.',',');
}

const getRatingHtml = (avg: number, count: number) => {
    
    const rating = String(avg);
    const cardRatingStars = createDomElementHandler("ab-stars", [], {rating});
    const cardRatingValue = createDomElementHandler("span", "ab-pc-1__rating-value", undefined, `${normalizeRatingValue(rating)}`);
    return [cardRatingValue,cardRatingStars];
}

const getCtaSpecsHtml = (id: string, purchaseScope?: PurchaseScope) => {
    return createProductSpecsLink(id, purchaseScope, {
      classes: ["ab-pc-1__cta", "ab-pc-1__cta--specs", "ab-btn", "ab-btn--outline"],
      label: 'Scheda Completa', href: 'javascript:void(null)',
    });
}

export {getBadgeTargetHtml, getBadgeRecommendedHtml, getRatingHtml, getCtaSpecsHtml}
